const MuiDialogOverrides = {
  MuiDialog: {
    defaultProps: {},
    styleOverrides: {
      paper: {
        boxShadow: 'none'
      }
    }
  },
  MuiBackdrop: {
    styleOverrides: {
      root: {
        backgroundColor: 'rgba(7, 35, 43, 0.18)'
      },
      invisible: {
        backgroundColor: 'transparent'
      }
    }
  },
  MuiDialogTitle: {
    styleOverrides: {
      root: ({
        theme,
        ownerState
      }) => ({
        ...theme.typography.heading,
        padding: theme.spacing(3, 3, 1, 3),
        display: 'flex',
        gap: theme.spacing(1),
        alignItems: 'center',
        ...(ownerState.type === 'extended' && {
          padding: theme.spacing(3, 3, 3.75, 3)
        })
      })
    }
  },
  MuiDialogContent: {
    styleOverrides: {
      root: ({
        theme
      }) => ({
        paddingTop: 0,
        paddingBottom: theme.spacing(2),
        borderTop: 0,
        '& .MuiListItem-root': {
          paddingLeft: theme.spacing(3),
          paddingRight: theme.spacing(3)
        }
      })
    }
  },
  MuiDialogActions: {
    styleOverrides: {
      root: ({
        theme
      }) => ({
        padding: theme.spacing(3),
        position: 'sticky',
        bottom: 0,
        background: theme.palette.background.paper,
        borderTop: `1px solid ${theme.palette.divider}`,
        '& > :not(:first-of-type)': {
          marginLeft: theme.spacing(2)
        }
      })
    }
  }
};

export { MuiDialogOverrides };
